// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"style_infoRow__1y2VM","label":"style_label__2UR42","entry":"style_entry__3GPCl"};